import { Plus } from "lucide-react";

import { withForm } from "~/components/form/app-form";
import { ArrayItemCard } from "~/components/form/fields/array-item-card";
import { Button } from "~/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card";

import { offerFormOptions } from "../offer-form-options";

export const TestimonialsSection = withForm({
  ...offerFormOptions,
  render: function Render({ form }) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Testimonials</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <form.Field name="testimonials" mode="array">
            {(arrayField) => (
              <>
                {(arrayField.state.value ?? []).map((item, i) => (
                  <ArrayItemCard
                    key={i}
                    index={i}
                    isFirst={i === 0}
                    isLast={i === (arrayField.state.value?.length ?? 0) - 1}
                    isDeleted={item._delete === true}
                    itemLabel="testimonial"
                    onMoveUp={() => arrayField.moveValue(i, i - 1)}
                    onMoveDown={() => arrayField.moveValue(i, i + 1)}
                    onToggleDelete={() =>
                      form.setFieldValue(
                        `testimonials[${i}]._delete`,
                        !item._delete,
                      )
                    }
                  >
                    <form.AppField name={`testimonials[${i}].content`}>
                      {(field) => (
                        <field.TextareaField label="Content" maxLength={500} />
                      )}
                    </form.AppField>
                    <form.AppField name={`testimonials[${i}].author`}>
                      {(field) => <field.TextField label="Author" required />}
                    </form.AppField>
                  </ArrayItemCard>
                ))}
                <Button
                  type="button"
                  variant="ghost"
                  onClick={() =>
                    arrayField.pushValue({
                      content: "",
                      author: "",
                      order: arrayField.state.value?.length ?? 0,
                      _delete: false,
                    })
                  }
                >
                  <Plus className="mr-2 h-4 w-4" /> Add Testimonial
                </Button>
              </>
            )}
          </form.Field>
        </CardContent>
      </Card>
    );
  },
});
